module.exports = __webpack_public_path__ + "img/9788989305095.468af9e5.jpg";